import React, { useState, useRef, useEffect } from 'react'
import { message } from 'antd'
import Icon from './Icon'
import UploadImg from './UploadImg'
import { MAX_REF_IMGS, IMG_LABELS } from './constants'
import { apiFetchRecentCollect, apiFetchRecentUsed } from './service'
import SubTabScrollList from './SubTabScrollList'

export default function RefImgsBlock({ refImgs, onAdd, onRemove, onClear, onOpenMeinianGallery, enabled = false }) {
  const [subTab, setSubTab] = useState('recent')
  const [subTabImgs, setSubTabImgs] = useState([])
  const [subTabLoading, setSubTabLoading] = useState(false)
  const [uploadingCount, setUploadingCount] = useState(0)
  const subTabCacheRef = useRef({ recent: null, used: null })
  const uploading = uploadingCount > 0

  useEffect(() => {
    if (!enabled) return
    if (subTabCacheRef.current[subTab] !== null) {
      setSubTabImgs(subTabCacheRef.current[subTab])
      return
    }
    setSubTabImgs([])
    setSubTabLoading(true)
    const req = subTab === 'recent' ? apiFetchRecentCollect() : apiFetchRecentUsed()
    req
      .then(res => {
        let imgs = []
        if (subTab === 'recent') {
          imgs = (res?.resultList || []).map(item => ({
            id: item.unionId ?? null,
            url: item.mainUrl || '',
          })).filter(item => item.url)
        } else {
          imgs = (res?.resultList || res?.list || []).map(item => ({
            id: item.id ?? item.picId ?? null,
            url: item.picUrl || item.imageUrl || item.url || '',
          })).filter(item => item.url)
        }
        subTabCacheRef.current[subTab] = imgs
        setSubTabImgs(imgs)
      })
      .catch(() => {
        subTabCacheRef.current[subTab] = []
        setSubTabImgs([])
      })
      .finally(() => setSubTabLoading(false))
  }, [enabled, subTab])

  const getRefImgLabel = i => IMG_LABELS[i + 1]
  const finishUpload = () => {
    setUploadingCount(count => Math.max(0, count - 1))
  }

  const handleUploadSuccess = (url, id) => {
    finishUpload()
    onAdd(url, id)
  }

  const handleUploadError = err => {
    finishUpload()
    message.error(err || '上传失败')
  }

  return (
    <div className="ref-imgs-block">
      <div className="ref-imgs-header">
        <div className="ref-imgs-header-left">
          <span className="ref-imgs-title">参考图</span>
          <span className="ref-imgs-count">已上传 {refImgs.length}/{MAX_REF_IMGS}</span>
        </div>
        {refImgs.length > 0 && (
          <button type="button" className="ref-imgs-clear" onClick={onClear}>
            <Icon type="zykj-shanchu" style={{ fontSize: '16px' }} />
            清空
          </button>
        )}
      </div>

      <div className="ref-imgs-grid">
        {refImgs.map((item, i) => (
          <div className="ref-img-item" key={item.id ?? item.url ?? i}>
            <div className="ref-img-item-box">
              <img src={item.url} alt={`ref-${i}`} />
            </div>
            <div className="ref-img-label">{getRefImgLabel(i)}</div>
            <button type="button" className="ref-img-remove" onClick={() => onRemove(i)}>
              <Icon type="zykj-guanbi" style={{ fontSize: '10px' }} />
            </button>
          </div>
        ))}
        {refImgs.length < MAX_REF_IMGS && (
          <UploadImg
            draggable
            multiple
            maxFileSize={25}
            onStart={() => setUploadingCount(count => count + 1)}
            onSuccess={handleUploadSuccess}
            onError={handleUploadError}
            className="ref-img-upload"
          >
            <div className="ref-img-placeholder">
              {uploading ? (
                <>
                  <span className="fdai-upload-spinner" />
                  <span>上传中...</span>
                </>
              ) : (
                <>
                  <Icon type="zykj-jiahao" />
                  <span>点击/拖拽上传</span>
                </>
              )}
            </div>
          </UploadImg>
        )}
      </div>

      <SubTabScrollList
        imgs={subTabImgs}
        loading={subTabLoading}
        subTab={subTab}
        onSubTabChange={setSubTab}
        refImgs={refImgs}
        onSelect={onAdd}
        onOpenMeinianGallery={onOpenMeinianGallery}
      />
    </div>
  )
}
